import {AbstractItem} from "@app/shared/classes/item";
import {Address} from "@app/shared/classes/address";
import {PartnerExternalContact} from "@app/shared/classes/partner-external-contact";
import {Type} from "class-transformer";
import {serializeType} from "@app/shared/classes/common";
import {ItemType} from "@app/shared/enums/item-type.enum";
import {isNullOrUndefined} from "@qntm-code/utils";
import {FundingType} from "@app/shared/enums/funding-type.enum";

export class ReceiptItem {
  id: number;
  version: number;

  prordItemId?: number;
  abstractItemId: number;

  subtype: ItemType;
  fundingType: FundingType;
  nameOrNumber: string;
  description: string;
  unitOfMeasureId: number;
  unitOfMeasureDescription: string;
  internalNotes: string;

  isTaxable: boolean;
  qtyOrdered: number;
  qtyAlreadyReceived: number;
  qtyReceived: number;
  qtyBackOrdered: number;
  actualUnitCost?: number;				      // set by add-line-item

  receivedAll?: boolean;                // transient

  @Type(serializeType(AbstractItem)) abstractItemDetail: AbstractItem;
}

export class Receipt {
  id?: number;
  version?: number;

  taxRate: number;
  receiptNumber?: string;
  receivedOn: string;
  referenceNumber?: string;

  contactId: number;
  purchaseOrderId: number;
  purchaseOrderNumber: string;
  purchaseReturnId?: number;
  receivedLocationId: number;
  @Type(serializeType(Address)) receivedAddressDetail: Address;

  shipToId: number;
  vendorId: number;
  vendorDetail: any;
  @Type(serializeType(Address)) vendorAddressDetail: Address;
  @Type(serializeType(PartnerExternalContact)) vendorContactDetail: PartnerExternalContact;
  @Type(serializeType(ReceiptItem)) receiptItems: ReceiptItem[];

  multipleReceiptsExist: boolean;
  associatedInvoiceSubmittedOrApproved: boolean;
  associatedInvoiceNumber: string;

  constructor(vendorId?: number) {
    if (vendorId) {
      this.vendorId = vendorId;
    }
    this.receiptItems = new Array<ReceiptItem>();
  }
}

export class ReceiptInfo {
  id: number;
  receiptNumber: string;
  vendorId: number;
  contactId: number;
  shipToId: number;

  referenceNumber?: string;
  purchaseOrderId?: number;

  constructor(vendorId?: number, referenceNumber?: string) {
    if (!isNullOrUndefined(vendorId)) {
      this.vendorId = vendorId;
    }
    if (!isNullOrUndefined(referenceNumber)) {
      this.referenceNumber = referenceNumber;
    }
  }
}
